// src/utils/getDistanceInKm.js
import { db } from "../firebase/config";
import { doc, getDoc } from "firebase/firestore";

export const getDistanceInKm = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Radius of the earth in km
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  return distance; // in km
};

// Synchronous fallback values
export let BUSINESS_LOCATION = {
  lat: 17.5232,
  lng: 78.2996,
  name: "Beerumguda"
};
export let MAX_DELIVERY_DISTANCE = 5;

// Async fetch from Firestore
export const fetchDeliverySettings = async () => {
  const docRef = doc(db, "app_settings", "general");
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    const data = docSnap.data();
    BUSINESS_LOCATION = {
      lat: data.businessLat || 17.5232,
      lng: data.businessLng || 78.2996,
      name: "Beerumguda"
    };
    MAX_DELIVERY_DISTANCE = data.deliveryRadius || 5;
    return { ...BUSINESS_LOCATION, radius: MAX_DELIVERY_DISTANCE };
  }
  return { ...BUSINESS_LOCATION, radius: MAX_DELIVERY_DISTANCE };
};

// Check if location is within delivery range (sync, for initial load)
export const isWithinDeliveryRange = (userLat, userLng) => {
  const distance = getDistanceInKm(userLat, userLng, BUSINESS_LOCATION.lat, BUSINESS_LOCATION.lng);
  return distance <= MAX_DELIVERY_DISTANCE;
};

// Async version for up-to-date settings
export const isWithinDeliveryRangeAsync = async (userLat, userLng) => {
  await fetchDeliverySettings();
  return isWithinDeliveryRange(userLat, userLng);
};

// Get delivery area based on coordinates (simplified version)
export const getDeliveryArea = (lat, lng) => {
  const distance = getDistanceInKm(lat, lng, BUSINESS_LOCATION.lat, BUSINESS_LOCATION.lng);
  if (distance <= 2) return "Beerumguda";
  if (distance <= 4) return "Near Beerumguda";
  if (distance <= 6) return "Outer Beerumguda";
  if (distance <= MAX_DELIVERY_DISTANCE) return "Extended Area";
  return "Out of Range";
}; 